// extracted by extract-css-chunks-webpack-plugin
module.exports = {"G-night":"_25URt","G-img-wrap":"_7rH-V","is-irregular":"_1QS1R","imgBox":"luVcq","slick-loading":"tAduK"};